import { Component, NgModule, EventEmitter } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRouting } from './app-routing.module';

import {MatMenuModule} from '@angular/material/menu';
import {MatMenuTrigger} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

import { routerTransition } from './_animations/inout.animation';

import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [routerTransition],
  host: {'[@routerTransition]': ''}
})

export class AppComponent {

  getState(outlet) {
    // console.log(outlet.activatedRouteData.state);
      return outlet.activatedRouteData.state;
    }

 // someMethod() {
 //   this.trigger.openMenu();
 // }

  title = 'HPLC Simulator';

}
